export default {"src":"/_next/static/media/close_green.b02e8a19.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};